var React = require('react');

function Linkedin (props) {
    return React.createElement("svg",props,React.createElement("g",{"stroke":"none","strokeWidth":"1","fill":"none","fillRule":"evenodd"},React.createElement("g",{"id":"icon-linkedin-alt","fill":"#000000","fillRule":"nonzero"},React.createElement("path",{"d":"M427,0 L34,0 C15,0 0,14 0,33 L0,427 C0,446 15,461 34,461 L427,461 C446,461 461,446 461,427 L461,33 C461,14 446,0 427,0 Z M140,385 L70,385 L70,177 L140,177 L140,385 Z M105,149 L105,149 C81,149 66,133 66,113 C66,93 82,77 105,77 C129,77 144,93 144,113 C144,133 129,149 105,149 Z M391,385 L321,385 L321,274 C321,246 311,227 286,227 C267,227 255,240 250,252 C248,257 248,263 248,269 L248,385 L178,385 C178,385 179,197 178,177 L248,177 L248,207 C257,193 274,172 311,172 C356,172 391,202 391,266 L391,385 Z M248,208 C248,207 248,207 248,207 L248,208 Z"}))));
}

Linkedin.defaultProps = {"width":"461px","height":"461px","viewBox":"0 0 461 461","version":"1.1"};

module.exports = Linkedin;

Linkedin.default = Linkedin;
